const actions = {
  KNOWLEDGEBASE_DATA_FETCH_BEGIN: 'KNOWLEDGEBASE_DATA_FETCH_BEGIN',
  KNOWLEDGEBASE_DATA_FETCH_SUCCESS: 'KNOWLEDGEBASE_DATA_FETCH_SUCCESS',
  KNOWLEDGEBASE_DATA_FETCH_ERR: 'KNOWLEDGEBASE_DATA_FETCH_ERR',

  knowledgebaseDataFetchBegin: () => ({
    type: actions.KNOWLEDGEBASE_DATA_FETCH_BEGIN,
  }),

  knowledgebaseDataFetchSuccess: (data) => ({
    type: actions.KNOWLEDGEBASE_DATA_FETCH_SUCCESS,
    data,
  }),

  knowledgebaseDataFetchFailed: (err) => ({
    type: actions.KNOWLEDGEBASE_DATA_FETCH_ERR,
    err,
  }),
};

export const {
  KNOWLEDGEBASE_DATA_FETCH_BEGIN,
  KNOWLEDGEBASE_DATA_FETCH_SUCCESS,
  KNOWLEDGEBASE_DATA_FETCH_ERR,
  knowledgebaseDataFetchBegin,
  knowledgebaseDataFetchSuccess,
  knowledgebaseDataFetchFailed,
} = actions;

export default actions;
